const colors = {
    primary: '#00B680', 
    secondary: '#6c757d',
    dark: '#121212',
    placeholderColor: '#606060',
    grey: '#D0D0D0',
    lightGrey: '#F1F1F1',
    red: '#C10606',
    transparentGreen: 'rgba(4, 78, 56, 0.7)',
    white: '#fff',
    lightGreen: "#C9F3E7",
    secondaryBlack: "#454545"
  };
  
  export default colors;